"use strict";

const Fancybox = () => {
    const init = () => {
        $(document).ready(function () {
            //////////////////////////////////////////////
            // Fancybox
            //////////////////////////////////////////////
            $('[data-fancybox]').fancybox({
                showNavArrows: false
            });
        });
    };

    return {
        init: init
    };
};

export default Fancybox;